export function isValidUrl(url?: string) {
  const pattern = new RegExp(
    '^(https?:\\/\\/)?' + // protocol
      '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // domain name and extension
      '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address
      '(\\:\\d+)?(\\/[-a-z\\d%_.~+@]*)*' + // port and path
      '(\\?[;&a-z\\d%_.~+=@-]*)?' + // query string
      '(\\#[-a-z\\d_@]*)?$',
    'i',
  ); // fragment locator
  return url && !!pattern.test(url);
}

const characterLimit = (limit: number, value?: string) => {
  if (value && value.length > limit) {
    return `TOO_LONG`;
  }
  return undefined;
};

const validateUrl = (value?: string) => {
  if (value && !isValidUrl(value)) {
    return `INVALID_URL`;
  }
  return undefined;
};

const InputValidator = {
  characterLimit,
  validateUrl,
};

export { InputValidator };
